// 所有接口暴露的地方
import request from '../network'; // 引用network.js
import portUrl from '../independent-module/url'; // 引用url.js
const qs = require('qs');
// 获取奖品/游戏
const tuijian = (data) => {
  return request({
    method: "post",
    data: data,
    url: portUrl.tuijian
  })
};
// 获取验证码
const getYzm = (data) => {
  return request({
    method: "post",
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data: qs.stringify(data),
    url: portUrl.getYzm
  })
}
// 手机号注册
const phoneReg = (data) => {
  return request({
    method: "post",
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data: qs.stringify(data),
    url: portUrl.phoneReg
  })
}
// 手机号登录
const accountLogin = (data) => {
  return request({
    method: "post",
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data: qs.stringify(data),
    url: portUrl.accountLogin
  })
}
// 预约游戏
const makeGame = (data) => {
  return request({
    method: "post",
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data: qs.stringify(data),
    url: portUrl.makeGame
  })
}

// 落地页
const landing = (data) => {
  return request({
    method: "post",
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data: qs.stringify(data),
    url: portUrl.landing
  })
}
// 手机快捷登录
const phoneFastLogin = (data) => {
  return request({
    method: "post",
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data: qs.stringify(data),
    url: portUrl.phoneFastLogin
  })
}
// 账号快捷登录
const accountFastLogin = (data) => {
  return request({
    method: "post",
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data: qs.stringify(data),
    url: portUrl.accountFastLogin
  })
}
// 子账号登录
const childAccount = (data) => {
  return request({
    method: "post",
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data: qs.stringify(data),
    url: portUrl.childAccount
  })
}
// 找回密码
const findPassWord = (data) => {
  return request({
    method: "post",
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data: qs.stringify(data),
    url: portUrl.findPassWord
  })
}
// 创建子账号
const addSubAccount = (data) => {
  return request({
    method: "post",
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data: qs.stringify(data),
    url: portUrl.addSubAccount
  })
}
// 绑定手机号
const bindMobile = (data) => {
  return request({
    method: "post",
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data: qs.stringify(data),
    url: portUrl.bindMobile
  })
}

export default {
  tuijian,
  getYzm,
  phoneReg,
  accountLogin,
  makeGame,
  landing,
  phoneFastLogin,
  accountFastLogin,
  childAccount,
  findPassWord,
  addSubAccount,
  bindMobile
}